import React, { useEffect, useState } from "react";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setAccessToken } from "../../api/axiosInstance";
import { handleApiValidationError } from "../../utils/apiErrorHandler";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Mail, Lock, UserPlus, User } from "lucide-react";

function ResetPassword() {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");

  useAlphabeticInput();

  const INITIAL_FORM_DATA = {
    newPassword: "",
    confirmPassword: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);
  const isValidPassword = formData.newPassword.length >= 6;

  const validate = () => {
    const newErrors = {};

    if (!formData.newPassword) {
      newErrors.newPassword = "Enter Password";
    } else if (!isValidPassword) {
      newErrors.newPassword = "Password must be at least 6 characters";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Enter Confirm Password";
    } else if (!isValidPassword) {
      newErrors.confirmPassword =
        "Confirm Password must be at least 6 characters";
    }

    if (formData.newPassword !== formData.confirmPassword) {
      newErrors.general = "Password & Confirm Password must be same";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!token) {
      setMessage("Invalid reset link.");
      return;
    }
  }, [token])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const res = await userAPI.resetPassword(token, formData);
      if (res.code === 200) {
        showSuccess(res.message);
        navigate("/users/login");
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    }
  };

  return (
    <>
      <div className="custom-registerpage-wrapper">
        <Container fluid className="h-100 p-0">
          <Row className="h-100 g-0">
            {/* Left Side: Editorial Image */}
            <Col
              lg={6}
              className="d-none d-lg-block custom-registerpage-imagebox"
            >
              <div className="register-image-overlay"></div>
            </Col>

            {/* Right Side: Login Form */}
            <Col
              lg={6}
              className="d-flex justify-content-center align-items-center p-4 p-md-5"
            >
              <div className="custom-registerpage-formbox">
                <h1 className="custom-registerpage-title mb-1">
                  Reset Password
                </h1>
                <p className="text-muted mb-5">
                  Enter details to reset your password
                </p>

                <Form method="post" onSubmit={handleSubmit}>
                  <Form.Group className="mb-md-3" controlId="password">
                    <Form.Label className="custom-form-label">
                      Password <span className="text-danger">*</span>
                    </Form.Label>
                    <div className="input-group-custom">
                      <Lock size={18} className="input-icon" />
                      <Form.Control
                        type="password"
                        name="newPassword"
                        placeholder="New Password"
                        value={formData.newPassword}
                        onChange={handleChange}
                      />
                    </div>
                    {errors && errors.newPassword && (
                      <span className="text-danger custom-input-span-text">{errors.newPassword}</span>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="confirmPassword">
                    <Form.Label className="custom-form-label">
                      Confirm Password <span className="text-danger">*</span>
                    </Form.Label>
                    <div className="input-group-custom">
                      <Lock size={18} className="input-icon" />
                      <Form.Control
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                      />
                    </div>
                    {errors && errors.password && (
                      <span className="text-danger custom-input-span-text">{errors.password}</span>
                    )}
                  </Form.Group>
                  <div>
                    {errors.general && (
                      <span className="text-danger">{errors.general}</span>
                    )}
                    {message && (
                      <span className="text-danger">{message}</span>
                    )}
                    <Button
                      className="custom-registerpage-submitbtn w-100 py-3"
                      type="submit"
                    >
                      RESET PASSWORD
                    </Button>
                    
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ResetPassword;
